import styled from '@emotion/styled'

export const ResetButton = styled('button')`
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 0.5em;
`
